var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tap',{class:[ 'action-button', 'button', 'is-primary', 'flex', 'is-centered', _vm.disabled && 'is-disabled' ],nativeOn:{"click":function($event){return _vm.tap($event)}}},[_c('span',{staticClass:"icon"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }